export const gallery = {
  title: "Life at Gándara",
  subtitle: "A space to grow, explore and discover"
};
